// @flow

import React from 'react'

type Props = {
  children: React$Node,
  className?: string,
}

const Container = ({ children, className }: Props) => {
  return (
    <div className={`mx-auto max-w-container px-5 md:px-16 ${className || ""}`}>
      {children}
    </div>
  )
}

export default Container
